<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'CONCEPTOS.LBL_CONCEPTOS' | translate}}" *ngIf="concepto">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{concepto.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{concepto.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_ANALIZAMOS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{concepto.indicadorAnalizamos ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_DINERO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{concepto.indicadorDinero ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{concepto.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label" *ngIf="concepto.indicadorDinero">{{ 'CONCEPTOS.LBL_REDONDEAR' | translate }}
            :</label>
          <label class="lg:col-3 col-6 md:col-8"
                 *ngIf="concepto.indicadorDinero"><strong>{{concepto.indicadorRedondear ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_SUMA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{concepto.indicadorSuma ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_RESTA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{!concepto.indicadorSuma ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_RANGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{concepto.indicadorRango ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_INDICADORANUAL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{concepto.indicadorAnual ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONCEPTOS.LBL_DESCRIPCION' | translate }}:</label>
          <label class="lg:col-9 col-6 md:col-8"><strong>{{concepto.descripcion }}</strong></label>
        </div>

      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
